<script>
import DetectStepItem from './DetectStepItem.vue'

export default {
  props: {
    active: {
      type: Number,
      default: 1
    },
    /**
     * name: '步骤名称'
     * status: '是否通过' 'success' 'fail' undefined
     * icon: '图标'
     */
    steps: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  components: {
    DetectStepItem
  }
}
</script>
<template>
  <div class="detect-steps">
    <template v-for="(step, idx) in steps">
      <DetectStepItem
        :key="step.name"
        :isActived="active === idx + 1"
        :num="idx + 1"
        :name="step.name"
        :status="step.status"
        :icon="step.icon"
      />
      <div
        :key="step.name + 'link'"
        class="detect-steps-link"
        v-if="idx < steps.length - 1"
      />
    </template>
  </div>
</template>
<style lang="scss" scoped>
.detect-steps {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.detect-steps-link {
  width: 0px;
  height: 64px;
  margin-left: 5px;
  margin-top: 6px;
  margin-bottom: 6px;
  border-left: 1px dashed #D1D7E1FF;
}
</style>
